export type LocacaoStatusBadgeVariant =
  | 'default'
  | 'secondary'
  | 'destructive'
  | 'outline'
  | 'warning'
  | 'success'
  | 'danger'
  | 'info';

/** Mapeia status_atual da locação para variante do Badge. */
export function getLocacaoStatusVariant(
  status: string | null | undefined
): LocacaoStatusBadgeVariant {
  const s = String(status ?? '')
    .trim()
    .toUpperCase();
  if (!s) return 'outline';
  if (s.includes('CANCEL')) return 'destructive';
  if (s === 'CONGELADA' || s === 'CONGELADO') return 'warning';
  if (s === 'FINALIZADA' || s === 'FINALIZADO') return 'secondary';
  if (s === 'ATIVA' || s === 'ATIVO' || s === 'APROVADA' || s === 'APROVADO') return 'success';
  return 'outline';
}

export function getClickSignBadgeVariant(
  status: string | null | undefined
): LocacaoStatusBadgeVariant {
  const s = String(status ?? '')
    .trim()
    .toUpperCase();
  if (!s || s === '—' || s === '-') return 'outline';
  if (
    s.includes('ASSIN') ||
    s.includes('FINAL') ||
    s.includes('CONCLU') ||
    s === 'CLOSED' ||
    s === 'SIGNED'
  ) {
    return 'success';
  }
  if (s.includes('PEND') || s.includes('AGUARD') || s.includes('WAIT')) return 'warning';
  if (s.includes('CANCEL') || s.includes('RECUS') || s.includes('ERROR')) return 'danger';
  return 'info';
}
